module.exports = __webpack_public_path__ + "img/import.37d02a4a.svg";